import AlertDialog from "@/shared/components/kit/modal";
import StackKit from "@/shared/components/kit/stack";
import TypoGraphyKit from "@/shared/components/kit/typoGraphy";
import { Grid } from "@mui/material";
import { toast } from "react-toastify";
import { numberSeparator } from "@/hooks/useThousandsSeparator";
import { fetchWalletBalance } from "@/api/user/home";
import { useQuery } from "@tanstack/react-query";

type CreditPaymentProps = {
  setModalCredit: (value: boolean) => void;
  modalCredit: boolean;
  installmentId: number;
  loanId: number;
  paymentAmount: number;
  walletBalance?: number;
  insBalancePay?: (installmentId: number, amount: number) => Promise<void>;
};



/**
 * CreditPayment
 *
 * کامپوننت پرداخت اقساط از کیف پول. در صورت موفقیت در پرداخت، صفحه ریست می‌شود.
 *
 * @param setModalCredit بستن یا باز کردن مودال پرداخت
 * @param modalCredit وضعیت باز بودن مودال
 * @param installmentId شناسه قسط
 * @param loanId شناسه وام
 * @param paymentAmount مبلغ قابل پرداخت
 * @param walletBalance موجودی کیف پول (اختیاری)
 * @param insBalancePay تابع اجرای پرداخت از کیف پول
 *
 * @returns JSX.Element
 */

const CreditPayment = ({setModalCredit,modalCredit,installmentId,loanId,paymentAmount,walletBalance = 5000000,insBalancePay,}: CreditPaymentProps) => {
  
  const { data } = useQuery({
    queryKey: ["wallet-balance"],
    queryFn: fetchWalletBalance,
  });

  const handleAgree = async () => {
    if (!data) return;

    if (paymentAmount > data.balance) {
      toast.error("موجودی کیف پول کافی نیست");
      return;
    }

    try {
      if (insBalancePay) {
        await insBalancePay(installmentId, paymentAmount);
      }

      toast.success("پرداخت از کیف پول با موفقیت انجام شد.");

      setModalCredit(false);

      // ====== RESET PAGE AFTER PAYMENT ======
      setTimeout(() => {
        window.location.reload();
      }, 500);

    } catch (error) {
      toast.error("خطا در انجام پرداخت");
      console.error(error);
    }
  };

  return (
    <AlertDialog
      open={modalCredit}
      onClose={() => setModalCredit(false)}
      onDisagree={() => setModalCredit(false)}
      onAgree={handleAgree}
      isHeader
      header={<TypoGraphyKit variant="h6">پرداخت از کیف پول</TypoGraphyKit>}
      disagreeText="بستن"
      agreeText="پرداخت"
      sx={{
        "& .MuiDialog-paper": {
          height: "auto",
          maxHeight: "fit-content",
          minHeight: "unset",
          width: "100%",
          maxWidth: "400px",
        },
      }}
    >
      <Grid sx={{ p: 2 }}>
        <TypoGraphyKit>
          شما در حال پرداخت کل مبلغ قسط از کیف پول خود می‌باشید.
        </TypoGraphyKit>

        <StackKit direction="row" gap={2} mt={2}>
          <TypoGraphyKit>
            موجودی کیف پول: {numberSeparator(data ? data.balance : 0)} ریال
          </TypoGraphyKit>
          <TypoGraphyKit>
            مبلغ قسط: {numberSeparator(paymentAmount)} ریال
          </TypoGraphyKit>
        </StackKit>
      </Grid>
    </AlertDialog>
  );
};

export default CreditPayment;